import { useContext, useEffect, useState } from "react";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { AppContext } from "../App";
import { t } from "../i18n";
import { NormalHourSelection } from "../components/NormalHourSelection";
import { BookingExpressHourSelection } from "../components/BookingExpressHourSelection";
import { BookingHourSelection } from "../components/BookingHourSelection";
import { sendEventToParent, extractTimeData } from "../utils/helpers";
import { eventResultStatusCodesMapfre, routes } from "../utils/symbols";
import CalendarBooking from "../components/CalendarBooking";
import { useWizardNavigation } from "../hooks/useWizardNavigation";
import { Icon } from "../components/Icon";

export const SelectDateTime = (props) => {
	const [hours, setHours] = useState(null);
	const { nextPage, previousPage } = useWizardNavigation();

	return (
		<>
			<Header hours={hours} />
			<Content hours={hours} setHours={setHours} />
			<Footer
				nextPage={nextPage}
				previousPage={previousPage}
				clearOnBack={["date", "time", "startTime", "endTime"]}
			/>
		</>
	);
};

const Content = ({ hours, setHours }) => {
	const { flow, data, setData, isTransitioning, navigate } =
		useContext(AppContext);
	const [loading, setLoading] = useState(false);

	const handleSearchAnotherCenter = () => {
		setData((prev) => ({
			...prev,
			date: null,
			time: null,
			startTime: null,
			endTime: null,
			reselectingCenter: true,
		}));
		navigate(routes.selectCenter);
	};

	const handleTimeSelection = (apt) => () => {
		const timeData = extractTimeData(apt)

		setData((prev) => ({
			...prev,
			...timeData,
		}));
		// Send Custom Tracking event to the funnel
		if (flow !== "mapfre") {
			window.parent.postMessage(
				{
					type: "fc-cita-time",
					data: {
						origin: data.origin,
					},
				},
				"*",
			);
		}
	};

	useEffect(() => {
		if (!data.centerCode || !data.date) return;

		setLoading(true);

		let apiUrl = process.env.REACT_APP_API_URL || "http://localhost:3000";

		let controller = new AbortController();
		let options = {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
			signal: controller.signal,
		};

		fetch(
			`${apiUrl}/availability/${data.centerCode}/${data.date}?locator=${data.locator}`,
			options,
		)
			.then((res) => res.json())
			.then((newData) => {
				if (newData.result === "ok") {
					const filteredData = newData.shifts.data.map((daySlots) =>
						daySlots.filter((slot) => slot.available === true)
					);
					const filteredShifts = {
						...newData.shifts,
						data: filteredData,
					};
					setHours(filteredShifts);
					setData((prevData) => ({
						...prevData,
						bookingType: newData.shifts.type,
					}));
				}
			})
			.catch((err) => {
				console.error(err);
				sendEventToParent(
					eventResultStatusCodesMapfre.ERROR_5XX,
					data,
					flow,
				);
			})
			.finally(() => {
				setLoading(false);
				controller.abort();
			});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data.centerCode, data.date, data.locator, setHours, setData]);

	return (
		<div
			className={
				"content content_calendar kensei_03" +
				(isTransitioning ? " fade-in" : "")
			}
		>
			<div className="content_center_name">
				{/* <span className="content_center_span">Taller</span> */}
				<h2 className="content_center_h2">Taller - {data.centerName}</h2>
				<p className="content_center_p">{data.centerAddress}</p>
			</div>

			{flow !== "mapfre" && (
				<div className="Alt-center">
					<button
						className="Alt-btn"
						onPointerDown={handleSearchAnotherCenter}
					>
						{/* <Icon name="calendar" /> */}
						<Icon name="arrow" />
						Busca en otro taller
					</button>
				</div>
			)}

			<div className="content_calendar_date">
				<CalendarBooking />
			</div>

			<div className="content_calendar_time">
				{loading ? (
					<div className="loader">
						<div className="spinner"></div>
					</div>
				) : hours?.type === "normal" ? (
					<NormalHourSelection
						hours={hours?.data}
						selected={data.time}
						onSelect={handleTimeSelection}
					/>
				) : hours?.type === "booking" ? (
					<BookingHourSelection
						hours={hours?.data}
						selected={data.time}
						onSelect={handleTimeSelection}
					/>
				) : hours?.type === "bookingExpress" ? (
					<BookingExpressHourSelection
						hours={hours?.data}
						selected={data.time}
						onSelect={handleTimeSelection}
					/>
				) : (
					hours &&
					((Array.isArray(hours) &&
						hours.every(
							(arr) => Array.isArray(arr) && arr.length === 0,
						)) ||
						(Array.isArray(hours.data) &&
							hours.data.every(
								(arr) => Array.isArray(arr) && arr.length === 0,
							))) && (
						<div className="content_time_info no-availability">
							<h4>
								{t(
									"No se han podido cargar las horas disponibles",
								)}
							</h4>
							<p>
								{t(
									"Por favor, intenta de nuevo más tarde o para ayudarte a gestionar tu cita.",
								)}
							</p>
						</div>
					)
				)}
			</div>
			{/* {flow !== "mapfre" && (
				<div className="Alt-center">
					<button
						className="Alt-btn"
						onPointerDown={handleSearchAnotherCenter}
					>
						{/* <Icon name="calendar" /> */}
						{/* <Icon name="arrow" />
						Busca en otro taller
					</button>
				</div>
			)} */}
		</div>
	);
};
